export default "__VITE_ASSET__c8cb3cc0__"